import { requestTool } from "../tools";

const login = (data, url) => {
    return requestTool.postRequest(url + "/api/token/get-token", data);
}
const sendResetPasswordLink = (data, url) =>
    requestTool.postRequest(url + "/api/token/reset-password/", data);

const changePassword = (data, url) =>
    requestTool.postRequest(url + "/api/token/change-password/", data);

const getLoginParameters = (url, data) => {
    return requestTool.getRequest(url + "/api/token/getLoginParameters", data);
}
const otpControl = (otp, userId, url) => requestTool.
    getRequest(url + "/api/token/otp-control?_otp=" + otp + "&_userId=" + userId);
const generateCaptcha = (url) => requestTool.
    getRequest(url + "/api/captcha/generate-captcha");

const sendOtpMail = (userId, url) => requestTool.
    getRequest(url + "/api/token/send-otp-mail?_userId=" + userId);
const validateCaptcha = (data, url) =>
    requestTool.postRequest(url + "/api/captcha/validate-captcha/", data);

export const authenticationService = { login, generateCaptcha, getLoginParameters, validateCaptcha, sendResetPasswordLink, changePassword, otpControl, sendOtpMail };

export default authenticationService;

